<template>
  <a class="container facility-line-box mb-3" :href="`/facilities/${facility.id}`">
    <div class="row facility-line-header">
      <div><h2 class="facility-line-title"><b>{{facility.name}} {{facility.sub_name}}</b><span><hr color="#a8aba6" class="span-line"></span><span class="facility-line-header-sub"><b>{{facility.facility_type}}</b></span></h2></div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="mt-2"><i class="fas fa-map-marker-alt mr-2"></i><span>{{facility.address}}</span></div>
        <div class="mt-2"><i class="fas fa-running mr-2"></i><span>{{facility.sports_types.join(' ')}}</span></div>
        <div class="mt-2 mb-2"><i class="fas fa-tag mr-2"></i>
          <span class="facility-line-tag" v-for="tag in facility.tags" :key="tag">{{tag}}</span>
        </div>
        <div class="mt-2 mb-2 availability-message" v-if="!isUnlogin && facility.has_booking_scraping_url && isDisplayAvailabilityNotificationStatus">
          <span style="margin-right: 8px; display: flex;">
            <img src="/images/calender-icon.svg"/>
          </span>
          <span style="margin-right: 4px; display: flex;"
            v-if="
            (facility.is_available_in_5_days && !(isPaidUser || isAdmin)) || 
            (facility.is_available_in_30_days && (isPaidUser || isAdmin))"
          >
            <img src="/images/empty-icon.svg"/>
          </span>
          <span style="margin-right: 4px; display: flex;" v-else>
            <img src="/images/black-cross-icon.svg"/>
          </span>
          <template v-if="isPaidUser || isAdmin">
            <span v-if="facility.is_available_in_30_days">
              <span v-if="!hasAvailabilityCondition">
                直近1ヶ月間で空きあり
              </span>
              <span v-else>
                空きあり
              </span>
            </span>
            <span v-else>直近1ヶ月間で空きなし</span>
          </template>
          <template v-else>
            <span v-if="facility.is_available_in_5_days">
              <span v-if="!hasAvailabilityCondition">
                直近5日間で空きあり
              </span>
              <span v-else>
                空きあり
              </span>
            </span>
            <span v-else>直近5日間で空きなし</span>
          </template>
        </div>
      </div>
    </div>
  </a>
</template>
<script>

export default {
  data() {
    return {
      
    }
  },
  props: {
    facility: {
      type: Object,
      default: {}
    },
    isAdmin:{
      type: Boolean,
      default: false
    },
    isUnlogin:{
      type: Boolean,
      default: false
    },
    isPaidUser:{
      type: Boolean,
      default: false
    },
    isDisplayAvailabilityNotificationStatus:{
      type: Boolean,
      default: false
    },
    hasAvailabilityCondition: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  methods: {
  },
  created(){
  },
  computed: {
  },
  watch: {
    
  }
}
</script>